// extracted by mini-css-extract-plugin
module.exports = {"container":"simple_snapshot_container__container__JDXzi"};